import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useLocation, NavLink, useHistory } from 'react-router-dom';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Button,
} from '@mui/material';

import {
  Menu as MenuIcon,
  ExitToApp as LogoutIcon,
} from '@mui/icons-material';

import Timer from '../Timer';

import parentPaths from '../../services/paths';
import { VALID_REFRESH_SCOPES, VALID_FILTER_SCOPES, VALID_SEARCH_SCOPES, PAGES_WITH_SECTIONS } from '../../services/constants';

import store from '../../redux/store';
import { logout } from '../../redux/actions/Account';
import { setHeaderCustomerName, setTableScope } from '../../redux/actions/TableData';

import CustomBreadcrumbs from '../utils/CustomBreadcrumbs';
import useSection from '../../services/hooks/useSection';
import localization from '../../localization';

import permissions from '../../services/permissions';
import { CRUD_RESTRICTION } from '../../services/constants/permissions';

const TopBar = ({ toggleDrawer, drawerOpen }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const scope = location.pathname.split('/').pop();
  const routes = location.pathname.split('/');

  const isTestBranch = parentPaths.config.branchName;

  // IAP-0000 example, 6 and 5 routes.length for environment
  const isTestStage = isTestBranch >= 9 ? 6 : 5;

  // Another logic with additional branch name in URL
  const isTestStageURL = isTestBranch >= 9 ? 4 : 3;

  const idForCopy = PAGES_WITH_SECTIONS.includes(scope) ? null : scope;

  const id = routes.length >= isTestStage ? idForCopy : null;

  const sections = useSection();

  const doLogout = () => {
    dispatch(logout());

    history.push(parentPaths.default);
  };

  const isCrudEnabled = permissions.checkRestriction(CRUD_RESTRICTION);

  const goToCrudHelper = () => {
    history.push(parentPaths.crudHelper.request);
  };

  useEffect(() => {
    if (!dispatch) return;
    const { tableData } = store.getState();

    if (scope &&
        tableData?.scope !== scope &&
        (VALID_REFRESH_SCOPES.includes(scope) ||
          VALID_FILTER_SCOPES.includes(scope) ||
          VALID_SEARCH_SCOPES.includes(scope)
        )) {
      dispatch(setTableScope(scope));
    }

    dispatch(setHeaderCustomerName(''));
  }, [scope, dispatch]);

  return (
    <AppBar position="static" className="top-bar" elevation={1} sx={{ zIndex: 9 }} style={{ height: '45px' }}>
      <Toolbar>
        {!drawerOpen &&
          (
          <Box pb={3}>
            <IconButton
              edge="start"
              aria-label="menu"
              color="secondary"
              onClick={toggleDrawer}
              size="large"
            >
              <MenuIcon />
            </IconButton>
          </Box>
          )}
        <Box display="flex" width={1} justifyContent="flex-start" pb={3}>
          <CustomBreadcrumbs
            sections={sections}
            url={routes.slice(0, -1).length <= isTestStageURL ? null : routes.slice(0, -1).join('/')}
            id={id}
          />
        </Box>
        <Box
          display="flex"
          justifyContent="flex-end"
          flexWrap="nowrap"
          pb={3}
          gap={4}
        >
          {isCrudEnabled && (
            <Button
              variant="outlined"
              color="primary"
              style={{
                margin: 'auto 0',
                height: 'max-content',
                padding: 0,
              }}
              onClick={goToCrudHelper}
            >
              {localization.t('general.crud')}
            </Button>
          )}
          <Timer />
          <Box display="flex" justifyContent="flex-end" flexWrap="nowrap">
            <IconButton
              component={NavLink}
              edge="start"
              aria-label="myAccount"
              color={scope !== 'myaccount' ? 'secondary' : 'primary'}
              to={parentPaths.myaccount}
              size="large"
            >
              <AccountCircleIcon />
            </IconButton>
            <IconButton
              edge="start"
              aria-label="logout"
              color="secondary"
              onClick={doLogout}
              size="large"
            >
              <LogoutIcon />
            </IconButton>
          </Box>

        </Box>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  toggleDrawer: PropTypes.func,
  drawerOpen: PropTypes.bool,
};

export default TopBar;
